import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, withModifiers as _withModifiers, createStaticVNode as _createStaticVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/arrow.svg'


const _withScopeId = n => (_pushScopeId("data-v-6c3fda7e"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "loader"
}
const _hoisted_2 = /*#__PURE__*/_createStaticVNode("<div class=\"sk-chase\" data-v-6c3fda7e><div class=\"sk-chase-dot\" data-v-6c3fda7e></div><div class=\"sk-chase-dot\" data-v-6c3fda7e></div><div class=\"sk-chase-dot\" data-v-6c3fda7e></div><div class=\"sk-chase-dot\" data-v-6c3fda7e></div><div class=\"sk-chase-dot\" data-v-6c3fda7e></div><div class=\"sk-chase-dot\" data-v-6c3fda7e></div></div>", 1)
const _hoisted_3 = [
  _hoisted_2
]
const _hoisted_4 = {
  key: 1,
  class: "list-group"
}
const _hoisted_5 = ["onClick"]
const _hoisted_6 = { class: "button-container" }
const _hoisted_7 = ["onClick"]
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: ""
}, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_ctx.isLoadingPlaces)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, _hoisted_3))
    : (_ctx.places.length > 0)
      ? (_openBlock(), _createElementBlock("ul", _hoisted_4, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.places, (place) => {
            return (_openBlock(), _createElementBlock("li", {
              key: place.id,
              class: _normalizeClass(["mycard", { 'active': place.id === _ctx.activePlace }]),
              onClick: ($event: any) => (_ctx.onPlaceClicked(place))
            }, [
              _createElementVNode("h5", {
                class: _normalizeClass({ 'txt-dark': place.id === _ctx.activePlace })
              }, _toDisplayString(place.text), 3),
              _createElementVNode("p", {
                class: _normalizeClass({ 'txt-dark': place.id === _ctx.activePlace })
              }, _toDisplayString(place.place_name), 3),
              _createElementVNode("div", _hoisted_6, [
                _createElementVNode("button", {
                  class: _normalizeClass(place.id === _ctx.activePlace ? 'btn-light' : 'btn-dark'),
                  onClick: _withModifiers(($event: any) => (_ctx.getRouteDirections(place)), ["self"])
                }, [
                  _createTextVNode(" Ver direcciones "),
                  _hoisted_8
                ], 10, _hoisted_7)
              ])
            ], 10, _hoisted_5))
          }), 128))
        ]))
      : _createCommentVNode("", true)
}